import {useRef} from "react";
import Modal from "@/Components/Modals/Modal";
import {Dialog} from '@headlessui/react';
import ModalFooter from "@/Components/Modals/ModalFooter";
import {Link} from "@inertiajs/inertia-react";

export default function DeletePerson({person, isOpen, setIsOpen, onSuccess, onError}) {
    let initialFocusRef = useRef(null)
    return (
        <Modal
            title={`Delete
            ${person.first_name} ${person.last_name} from Organization`}
            initialFocusRef={initialFocusRef}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
        >
            <div>
                <Dialog.Description as="p" ref={initialFocusRef}>
                    Are you sure you want to delete {person.name} from your organization?
                </Dialog.Description>
            </div>
            <ModalFooter>
                <button
                    className="btn btn-outline-secondary"
                    onClick={() => setIsOpen(false)}
                    style={{ marginRight: '6px'}}
                >Cancel
                </button>
                <Link
                    href={`${route('manage.people.destroy', {user: person,})}${window.location.search}`}
                    as="button"
                    method="delete"
                    type="button"
                    className="btn btn-danger"
                    onSuccess={() => typeof onSuccess === 'function' ? onSuccess() : setIsOpen(false)}
                    onError={() => typeof onError === 'function' ? onError() : setIsOpen(false)}
                >Yes, Delete
                </Link>
            </ModalFooter>
        </Modal>
    );
}
